import React from "react";
import { m } from "framer-motion";

const industries = [
	{ icon: "Customer Service", label: "Customer Service" },
	{ icon: "Banking", label: "FinTech & Banking" },
	{ icon: "Transport and Logistics", label: "Logistics" },
	{ icon: "Education", label: "Education" },
	{ icon: "Engineering", label: "Engineering" },
	{
		icon: "Sales, Marketing and Business Development",
		label: "Sales & Marketing",
	},
];

function IndustriesSection() {
	return (
		<m.section
			className="py-10 sm:py-12"
			initial={{ opacity: 0 }}
			whileInView={{ opacity: 1 }}
			viewport={{ once: true, margin: "-48px" }}
			transition={{ duration: 0.6 }}
		>
			<div className="max-w-6xl mx-auto px-4">
				<p className="text-center font-inter text-xs font-semibold text-gray-400 tracking-[0.15em] uppercase mb-8">
					Hiring across industries
				</p>
				<div className="flex flex-wrap justify-center gap-3">
					{industries.map((item) => (
						<span
							key={item.label}
							className="inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-gray-50 font-inter text-sm text-gray-600"
						>
							<img src={`/images/landing/${item.icon}.svg`} alt="" className="w-4 h-4 opacity-50" />
							{item.label}
						</span>
					))}
				</div>
			</div>
		</m.section>
	);
}

export default IndustriesSection;
